import { Injectable } from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  Observable
} from 'rxjs';

import {
  environment
} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DigitalDownloadService {

  private apiUrl =
    environment.baseURL;

  constructor(
    private http: HttpClient
  ) {}

  /**
   * ======================================
   * CREATE ORDER
   * ======================================
   */
  createOrder(
    payload: any
  ): Observable<any> {

    return this.http.post(

      `${this.apiUrl}api/f/digital-download/create-order`,

      payload

    );

  }

  /**
   * ======================================
   * CHECK PURCHASE
   * ======================================
   */
  checkPurchase(
    payload: any
  ): Observable<any> {

    return this.http.post(

      `${this.apiUrl}api/f/digital-download/check-purchase`,

      payload

    );

  }

  /**
   * ======================================
   * TRACK DOWNLOAD
   * ======================================
   */
  trackDownload(
    payload: any
  ): Observable<any> {

    return this.http.post(

      `${this.apiUrl}api/f/digital-download/track-download`,

      payload

    );

  }


  /**
 * ======================================
 * CAPTURE ORDER
 * ======================================
 */
captureOrder(
  payload: any
): Observable<any> {

  return this.http.post(

    `${this.apiUrl}api/f/digital-download/capture-order`,

    payload

  );

}

}